import "./PdtCatList.css";

import { Link } from "react-router-dom";

import {getRootUrl, getBkendUrl, getJsonPath} from "../../consts";

import { sortToTree } from "../Tree/Tree.jsx";

import { useTbl, regUses } from "../../axios_with_token.js";

const rootUrl = getRootUrl();


// get array of pdtCatId and subIds
export const getPdtCatGrp = (pdtCatId, pdtCats)=>{
    const pdtCatGrp = [parseInt(pdtCatId)];

    pdtCats.forEach(pdtCat=>{
        if(pdtCatGrp.indexOf(parseInt(pdtCat.__pid))>=0){
            pdtCatGrp.push(parseInt(pdtCat.__id));
        }
    });

    return pdtCatGrp;
}

export const getPdtCatUpperGrp = (pdtCatId, pdtCats)=>{
  const pdtCatGrp = [parseInt(pdtCatId)];

  let out=[];
  let tmpCat = pdtCats.find(pdtCat=>parseInt(pdtCat.__id)==parseInt(pdtCatId));
  if(!tmpCat)return out;

  out.push(tmpCat)
  while(tmpCat.__pid){
    tmpCat = pdtCats.find(pdtCat=>parseInt(pdtCat.__id)==parseInt(tmpCat.__pid));
    out.push(tmpCat)
  }

  return out.reverse();
}

export const getSubPdtCats = (pdtCatId, pdtCats)=>{
  const pdtCatGrp = (pdtCatId||'').split(',').filter(a=>a).map(a=>parseInt(a));
  const out = [];
  (pdtCats||[]).forEach(pdtCat=>{
      if(pdtCatGrp.indexOf(parseInt(pdtCat.__pid))>=0){
          // pdtCatGrp.push(parseInt(pdtCat.__id));
          out.push(pdtCat)
      }
  });

  // console.log('out:', pdtCatId, pdtCats, out)
  return out;
}

export const getPdtCatsUrl = `${getBkendUrl()}/jwt/gettblrcds/${getJsonPath()}/pdtCats`;

export default function PdtCatList(props){
    const {regUse, isLoading, hasError, getErrMsgs, DefaultLoading, DefaultError} = regUses();

    const {data:pdtCatsTbl} = regUse(useTbl('pdtCats'));



    if(isLoading())return <DefaultLoading></DefaultLoading>;
    if(hasError())return <DefaultError></DefaultError>;

    const pdtCats = pdtCatsTbl.rcds;

    const pdtCatGroups = [];
    pdtCats.forEach(pdtCat=>{
        if(!pdtCat.__pid){
            pdtCatGroups.push([pdtCat]);
        }else{
            (pdtCatGroups.length>0)&&pdtCatGroups[pdtCatGroups.length-1].push(pdtCat);
        }
    });

    const pdtCatsTree = sortToTree(false, pdtCats);
    const showTree = (treeData, treeIdx, level)=>{
        level=level || 0;
        const pdtCat = treeData.obj;
        return <div key={`${level}-${treeIdx}`}
            className="product-categories ps-2 col"
        >
            <Link 
                // key={treeIdx}
                className="nav-link link-dark p-1 row" href="#"
                // onClick={handleClickCategory}
                catid={pdtCat.__id}
                to={rootUrl + "/app2/pdtDetail/" + pdtCat.__id}
            >{pdtCat.name}</Link>
            {(treeData.subs||[]).map((subTreeData, subTreeIdx)=>showTree(subTreeData, subTreeIdx, level+1))}
        </div>
    }

    return <div className="dropdown-menu shadow-sm p-4">
    <form className="product-list">
        <div className="d-flex bd-highlight p-3 row">
            {/* {
                " ".repeat(colMaxCnt).split(" ").map((_,col)=><div key={"col-"+col} className="flex-fill bd-highlight" >
                    {
                        pdtCats.slice(col*colMaxCnt, col*colMaxCnt+rowMaxCnt).map(rcd=><div key={rcd.__id}>
                            <Link className="nav-link link-dark p-1" href="#"
                                // onClick={handleClickCategory}
                                catid={rcd.__id}
                                to={rootUrl + "/app2/pdtCatDetail/" + rcd.__id}
                            >{rcd.name}</Link>
                        </div>)
                    }
                </div>)
            } */}
            {/* {pdtCats.map(rcd=>{
                return <div className="row">
                    <Link className="nav-link link-dark p-1 row" href="#"
                        // onClick={handleClickCategory}
                        catid={rcd.__id}
                        to={rootUrl + "/app2/pdtCatDetail/" + rcd.__id}
                    >{rcd.name}</Link>
                </div>
            })} */}

{(pdtCatsTree.subs||[]).map((subTreeData, subTreeIdx)=>showTree(subTreeData, subTreeIdx))}
            {/* {pdtCatGroups.map((pdtCatGroup, pdtCatGrpIdx)=>{

                return <div 
                    key={pdtCatGrpIdx}
                    className="col"
                >
                    
                    {
                            pdtCatGroup.map((pdtCat, pdtCatIdx)=>{
                                return <Link 
                                    key={pdtCatIdx}
                                    className="nav-link link-dark p-1 row" href="#"
                                    // onClick={handleClickCategory}
                                    catid={pdtCat.__id}
                                    to={rootUrl + "/app2/pdtCatDetail/" + pdtCat.__id}
                                >{pdtCat.name}</Link>
                            })
                    }
                    
                </div>
            })} */}
        </div>
    </form>
    <div className="dropdown-divider"></div>
    <a className="dropdown-item" href="#">Want to be Kept updated with new products? register news letter.</a>
    <div className="input-group mb-3 p-3">
        <label className="input-group-text" htmlFor="inputGroupFile01">register</label>
        <input type="email" className="form-control" id="inputGroupFile01" placeholder="email address"/>
    </div>

  </div>;
}